import { BLUE_COLOR, GREEN_COLOR, MEDIUM_GREY, ORANGE_COLOR_CHART, PRIMARY_BLACK } from "constants/globalConstants";

export const previewLayout = {
  margin: {
    l: 40,
    r: 50,
    b: 20,
    t: 25
  },
  autosize: true,
  tracetoggle: false,
  xaxis: {
    linecolor: PRIMARY_BLACK,
    linewidth: 1,
    fixedrange: true,
    domain: [0.1, 1],
    ticklen: 0,
    tickangle: "0",
    mirror: true,
    ticks: "outside",
    showline: true,
    tickfont: { size: 9 }
  },
  yaxis: {
    linecolor: PRIMARY_BLACK,
    linewidth: 1,
    fixedrange: true,
    mirror: true,
    ticks: "outside",
    showline: true,
    titlefont: { color: BLUE_COLOR },
    tickfont: { color: BLUE_COLOR }
  },
  yaxis2: {
    rangemode: "tozero",
    anchor: "x",
    overlaying: "y",
    side: "right",
    titlefont: { color: ORANGE_COLOR_CHART },
    tickfont: { color: ORANGE_COLOR_CHART },
    showticks: true,
    showline: true,
    linecolor: PRIMARY_BLACK,
    linewidth: 1,
    fixedrange: true
  },
  yaxis3: {
    rangemode: "tozero",
    anchor: "free",
    overlaying: "y",
    side: "left",
    titlefont: { color: GREEN_COLOR },
    tickfont: { color: GREEN_COLOR },
    position: -0.5,
    fixedrange: true
  },
  title: false,
  showlegend: true,
  legend: {
    orientation: "h",
    bgcolor: "transparent",
    x: 0.5,
    y: -0.95,
    xanchor: "center",
    yanchor: "bottom",
    font: {
      size: 10
    },
    itemsizing: "constant"
  }
};

export const previewPopupLayout = {
  autosize: true,
  tracetoggle: true,
  xaxis: {
    showgrid: true,
    showline: true,
    gridcolor: MEDIUM_GREY,
    gridwidth: 1,
    linecolor: PRIMARY_BLACK,
    linewidth: 1,
    domain: [0.1, 1]
  },
  yaxis: {
    showgrid: true,
    showline: true,
    gridwidth: 1,
    linewidth: 1,
    rangemode: "tozero"
  },
  yaxis2: {
    showgrid: true,
    showline: true,
    gridwidth: 1,
    linewidth: 1,
    anchor: "x",
    overlaying: "y",
    side: "right"
  },

  yaxis3: {
    showgrid: true,
    showline: true,
    anchor: "free",
    overlaying: "y",
    side: "left",
    position: 0.2
  },
  showlegend: true,
  title: true,
  legend: {
    orientation: "h",
    bgcolor: "transparent"
  }
};

export const plotConfig = { displayModeBar: false, staticPlot: true, format: "png" };

export const imageConfig = { format: "png", scale: 2, height: 240 };

export const generateReportImageConfig = { height: 400, width: 800, format: "png" };

export const generateReportPlotConfig = {
  ...previewLayout,
  margin: {
    l: 40,
    r: 40,
    b: 40,
    t: 40
  },
  titlefont: {
    size: 25,
    color: PRIMARY_BLACK
  },
  legend: {
    ...previewLayout.legend,
    y: -0.2,
    itemsizing: "constant"
  }
};
